import { Button } from "components/shared/panda/Button"
import PortableTitle from "components/shared/PortableTitle"
import { useSizing } from "lib/helpers"
import { urlForImage } from "lib/sanity.image"
import { LandingHeader } from "schemas"
import { Container, Grid, styled, VStack } from "styled-system/jsx"

type Props = LandingHeader

function Columns({
  subtitle,
  title,
  body,
  image,
  whiteBackground,
  cta,

  sizingTop,
  sizingBottom,
}: Props) {
  return (
    <styled.div
      className="landingHeader"
      style={
        {
          "--pt": useSizing(sizingTop) || "25px",
          "--pb": useSizing(sizingBottom) || "80px",
        } as React.CSSProperties
      }
      css={{
        pt: "calc(var(--pt) + 120px)",
        pb: "var(--pb)",
        mt: "-120px",
        bg: whiteBackground ? undefined : "#000A3A",
        color: whiteBackground ? "primary.1" : "#F2F2F5",
      }}>
      <Container>
        <Grid
          columns={{ lg: 2 }}
          rowGap={10}
          columnGap={20}
          gridTemplateColumns={{ lg: "5fr 4fr" }}
          alignItems="center">
          <VStack gap={6} alignItems="start">
            <styled.p
              css={{
                color: "#B496FF",
                fontFamily: "heading",
                fontSize: { base: "24px", lg: "28px" },
                fontWeight: "600",
                lineHeight: "136%",
              }}>
              {subtitle}
            </styled.p>
            <PortableTitle
              as="h1"
              css={{
                fontFamily: "heading",
                fontSize: { base: "32px", lg: "46px" },
                fontWeight: 600,
                lineHeight: "136%",

                "& em": {
                  position: "relative",
                  color: "transparent",

                  "&:after": {
                    content: "attr(data-text)",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "white",
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "110%",
                    height: "80%",
                    bg: "red",
                    // rounded: "1em",
                    rounded: "110px",
                    background:
                      "linear-gradient(270deg, #FFB48A 0%, rgba(218, 166, 251, 0.00) 94.48%)",
                    zIndex: 0,
                  },
                },
              }}>
              {title}
            </PortableTitle>
            <styled.p
              css={{
                fontSize: { base: "15px", lg: "20px" },
                lineHeight: "133%",
              }}>
              {body}
            </styled.p>
          </VStack>
          {cta && (
            <styled.div
              hideFrom="lg"
              css={{
                maxW: "740px",
              }}>
              <Button
                variant="filled"
                fillColor="primary"
                color="white"
                responsive
                href="/demo">
                {cta.text}
              </Button>
            </styled.div>
          )}
          {image && (
            <styled.img
              alt={image.alt || ""}
              src={urlForImage(image).url()}
              css={{
                minW: "min(110%, 80vw)",
                mr: "-10%",
              }}
            />
          )}
        </Grid>

        {cta && (
          <styled.div
            hideBelow="lg"
            css={{
              maxW: "740px",
            }}>
            <Button
              variant="filled"
              fillColor="primary"
              color="white"
              responsive
              href="/demo">
              {cta.text}
            </Button>
          </styled.div>
        )}
      </Container>
    </styled.div>
  )
}

export default Columns
export type { Props as ColumnsProps }
